<template>
  <div class="studyplan-order-info">
    <!-- 报名表单 -->
    <div class="form-info">
      <!-- 计划图片 -->
      <div class="goods-img">
        <img v-if="selectedPlan.planCover" :src="selectedPlan.planCover" />
      </div>
      <!-- 报名信息 -->
      <div class="goods-info">
        <div class="goods-column">
          <div class="column-lable">友邻少年ID</div>
          <div class="column-value">{{ userId }}</div>
        </div>
        <div class="line"></div>
        <div class="goods-column">
          <div class="column-lable">学习计划</div>
          <div class="column-value">{{ selectedPlan.goodsName }}</div>
        </div>
      </div>
      <!-- 报名输入内容 -->
      <div class="goods-textarea">
        <textarea
          v-model="form.joinInfo"
          cols="30"
          rows="10"
          maxlength="1000"
          placeholder="请简述您选择本计划的原因，非必填项"
        ></textarea>
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="form-submit" @click="submit">
      <span class="btn-text">确认报名</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { appUser } from '@/utils'
import { Toast } from 'mint-ui'

export default {
  name: 'studyplan-order-info',
  data() {
    return {
      form: {
        joinInfo: ''
      }
    }
  },
  computed: {
    ...mapGetters('goods/vip', ['termInfo']),
    ...mapGetters('goods-studyplan/plan', ['selectedPlan']),
    userId() {
      return appUser.userId
    }
  },
  methods: {
    submit() {
      // if(this.form.joinInfo == ""){
      //   Toast({ message:'请输入选择该计划原因' })
      //   return;
      // }
      const { form, termInfo, selectedPlan } = this
      form.userId = this.userId
      form.termId = termInfo.termId
      form.goodsId = selectedPlan.goodsId
      this.$emit('submit', form)
    }
  }
}
</script>

<style lang="less" scoped>
.studyplan-order-info {
  background: url('../../../../../images/goods-studyplan/planorder_bg.png') no-repeat;
  background-size: 100% 100%;
  padding-top: 0.75rem;
  // padding-bottom: 8rem;
  // 计划的表单
  .form-info {
    margin: 0 0.36rem;
    padding: 0.28rem;
    border-radius: 0.09rem;
    background: #ffffffff;
    // 计划图片
    .goods-img {
      min-height: 3.6rem;
      img {
        margin-bottom: 0.28rem;
        width: 100%;
        height: 3.6rem;
      }
    }
    // 计划信息
    .goods-info {
      display: flex;
      align-items: center;
      background: #ffeee0d4;
      .goods-column {
        text-align: center;
        flex: 1;
        margin: 0.37rem 0;
        .column-lable {
          font-size: 0.22rem;
          color: rgba(104, 49, 0, 0.6);
          line-height: 0.31rem;
          margin-bottom: 0.09rem;
        }
        .column-value {
          font-size: 0.3rem;
          color: #683100;
          font-weight: bold;
          line-height: 0.42rem;
        }
      }
      .line {
        height: 0.28rem;
        border-left: 1px solid #683100;
      }
    }
    // 输入报名信息
    .goods-textarea textarea {
      width: 100%;
      margin-top: 0.28rem;
      padding: 0.28rem;
      border-width: 0;
      background: #f5f5f5;
      color: #000000; // 输入的文本颜色
      outline: none;
      font-size: 0.26rem;
      -webkit-user-select: auto !important;
      caret-color: #888;
      &::-webkit-input-placeholder {
        color: #999999ff;
      }
    }
  }
  // 报名按钮
  .form-submit {
    width: 100%;
    height: 1.12rem;
    background: url('../../../../../images/goods-studyplan/planorder_submit-bg.png') no-repeat;
    background-size: 100% 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    text-align: center;
    padding-top: 0.37rem;
    // iphoneX only
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: #fff;
    .btn-text {
      font-size: 0.34rem;
      font-weight: bold;
      color: #5e361e;
      line-height: 0.47rem;
    }
  }
}
</style>
